export default __webpack_public_path__ + "static/media/home.52c0284c.svg";